"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSystemRole = exports.hasSystemRoleKind = exports.hasOrganizationKind = exports.hasUserKind = exports.hasApiKeyKind = exports.hasProjectKind = exports.untag = exports.CustomRoleId = exports.SystemRoleId = exports.ProjectId = exports.OrganizationId = exports.ApiKeyId = exports.UserId = void 0;
const UserId = (id) => `user/${id}`;
exports.UserId = UserId;
const ApiKeyId = (id) => `apiKey/${id}`;
exports.ApiKeyId = ApiKeyId;
const OrganizationId = (id) => `organization/${id}`;
exports.OrganizationId = OrganizationId;
const ProjectId = (id) => `project/${id}`;
exports.ProjectId = ProjectId;
const SystemRoleId = (role) => `system/${role}`;
exports.SystemRoleId = SystemRoleId;
const CustomRoleId = (id) => `custom/${id}`;
exports.CustomRoleId = CustomRoleId;
/** untag strips the leading `kind/` prefix from a tagged id. */
const untag = (tagged) => tagged.slice(tagged.indexOf("/") + 1);
exports.untag = untag;
/** hasProjectKind narrows an owner/resource id to a project. */
const hasProjectKind = (id) => id.startsWith("project/");
exports.hasProjectKind = hasProjectKind;
/** hasApiKeyKind narrows a principal id to an api key. */
const hasApiKeyKind = (id) => id.startsWith("apiKey/");
exports.hasApiKeyKind = hasApiKeyKind;
/** hasUserKind narrows a principal id to a user. */
const hasUserKind = (id) => id.startsWith("user/");
exports.hasUserKind = hasUserKind;
/** hasOrganizationKind narrows an owner/resource id to an organization. */
const hasOrganizationKind = (id) => id.startsWith("organization/");
exports.hasOrganizationKind = hasOrganizationKind;
/** hasSystemRoleKind narrows a role id to an in-code system role. */
const hasSystemRoleKind = (id) => id.startsWith("system/");
exports.hasSystemRoleKind = hasSystemRoleKind;
/** toSystemRole maps a system role id to its `SystemRole` enum member. */
const toSystemRole = (id) => (0, exports.untag)(id);
exports.toSystemRole = toSystemRole;
